import React, { useEffect, useState } from 'react'
import { Container, Row ,Col} from 'react-bootstrap'
import ImgOffer from "../assets/images/products/banner-1.jpg"
import { Puff } from 'react-loader-spinner';
import axios from 'axios';

const ClientPage = () => {
  const [isLoading, setIsLoading] = useState(true);
 
  useEffect(() => { 
    const delay = 1000;
    setTimeout(() => {
      setIsLoading(false);
    }, delay);
    fetchClient()
  }, []);
  const [clientData, setClientData] = useState([]);

  const fetchClient = async () => {
    try {
      const res =await  axios.get(
        `${process.env.REACT_APP_API_URL}/api/auth/list/ClientMaster`
      ) 
      setClientData(res.data);
    }
    catch (error) {
      console.log(error)
    }
  }
  return (
    <React.Fragment>
      {isLoading ? ( 
        <div className="loader-container">
          <Puff
            color="#a01e20"
            height={50}
            width={50}
            timeout={0} 
          />
        </div>
      ) : (
        <div>
         
            <nav class="breadcrumb-nav mb-10">
              <div class="container">
                <ul class="breadcrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <a href="#">All Client</a>
                  </li>
                </ul>
              </div>
            </nav>
            <Row className="px-3 px-md-5">
  {clientData &&
    clientData.map((client, index) => (
      <Col
        key={index}
        xs={6}     // mobile → 2 items per row
        sm={4}     // small tablets → 3 per row
        md={3}     // tablets → 4 per row
        lg={2}     // laptop → 6 per row
        xl={2}     // large screens → 6 per row
        className="mb-4 text-center"
      >
        <div className="post overlay-zoom">
          <figure className="post-media br-sm">
            <img
              src={`${process.env.REACT_APP_API_URL}/${client.logo}`}
              style={{ backgroundColor: client.backgroundColor }}
              alt={client.title}
              className="img-fluid"
            />
          </figure>
        </div>
      </Col>
    ))}
</Row>

           
        </div>
      )}
    </React.Fragment>
  )
}

export default ClientPage